// components/Navbar.js
import React from "react";
import { Link } from "react-router-dom";

const Navbar = ({ user, logout, toggleSidebar, isSidebarOpen }) => {
  return (
    <div className="fixed top-0 left-0 right-0 bg-gray-900 z-50 border-b border-gray-800 shadow-lg">
      <div className="container mx-auto px-4 py-2 md:p-4">
        <div className="flex items-center gap-4">
          {/* Sidebar Toggle Button */}
          <button
            className="md:hidden p-2 text-gray-100 hover:bg-gray-800 rounded-lg transition-colors"
            onClick={toggleSidebar}
            aria-label={isSidebarOpen ? "Close sidebar" : "Open sidebar"}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d={
                  isSidebarOpen
                    ? "M6 18L18 6M6 6l12 12"
                    : "M4 6h16M4 12h16M4 18h16"
                }
              />
            </svg>
          </button>

          {/* Logo */}
          <h1 className="text-xl md:text-3xl font-bold text-gray-100 flex-shrink-0">
            AI Chat App
          </h1>

          {/* Spacer */}
          <div className="flex-grow" />

          {/* Navigation Buttons */}
          <div className="flex items-center gap-2 md:gap-4">
            <Link
              to="/about"
              className="bg-gray-700 text-gray-100 px-2 py-1 md:px-4 md:py-2 rounded text-sm md:text-base hover:bg-gray-600 transition-colors"
            >
              About
            </Link>

            {user?.role === "admin" && (
              <Link
                to="/admin/stats"
                className="bg-blue-700 text-gray-100 px-2 py-1 md:px-4 md:py-2 rounded text-sm md:text-base hover:bg-blue-600 transition-colors"
              >
                Admin
              </Link>
            )}
            <button
              onClick={logout}
              className="bg-red-900 text-gray-100 px-2 py-1 md:px-4 md:py-2 rounded text-sm md:text-base hover:bg-red-800 transition-colors"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
